<!-- header -->
<template>
  <div id='header'>
    <div class="wrap">
      <!-- <img src="/img/logo-white.png" alt="logo" class="logo"> -->
      <ul class="menuList">
        <li v-for="(item,index) in menuList" class="menuList__item" :class="[{active: routeActive(item)}]" :key="index" @click="go(item)">
          {{ item.title }}
          <span class="point" v-if="routeActive(item)"></span>
        </li>
      </ul>
      <div class="user-wrap">
        <img :src="userUrl||'/img/avatar.png'" alt="avatar" class="avatar">
        <span class="user-name">{{userName}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
// import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      menuList: [
        // {
        //   path: process.env.VUE_APP_BEIKE_URL,
        //   title: '备课',
        //   external: true,
        //   role: '教师'
        // },
        // {
        //   path: process.env.VUE_APP_SHOUKE_URL,
        //   title: '授课',
        //   external: true,
        //   role: '教师'
        // },
        // {
        //   path: process.env.VUE_APP_MALL_URL,
        //   title: '商城',
        //   external: true,
        //   role: ['校长', '教务']
        // },
        // {
        //   path: process.env.VUE_APP_JIAOWU_URL,
        //   title: '学校管理',
        //   external: true,
        //   role: ['校长', '教务']
        // },
        {
          path: process.env.VUE_APP_MAIN_URL,
          name: 'live',
          title: '魔法培训营报名',
          role: '校长'
        }
        // {
        //   path: process.env.VUE_APP_SETTING_URL,
        //   title: '账户设置',
        //   external: true,
        //   role: ['校长', '教务']
        // },
        // {
        //   path: process.env.VUE_APP_ABOUT_URL,
        //   title: '关于我们',
        //   external: true,
        //   icon: 'icon-about'
        // },
        // {
        //   path: process.env.VUE_APP_QA_URL,
        //   title: '帮助中心',
        //   external: true,
        //   icon: 'icon-about'
        // }
      ],
      userUrl: '',
      userName: ''
    }
  },
  created () {
    this.userUrl = getUser().avatar_url
    this.userName = getUser().name
  },
  methods: {
    hasPermission (role) {
      let roles = getUser().role_name
      roles.split(',')
      if (typeof role === 'string') {
        return roles.indexOf(role) > -1
      }
      // 角色是数组
      if (Array.isArray(role)) {
        return role.some(v => roles.indexOf(v) > -1)
      } else {
        return true
      }
    },
    routeActive (item) {
      return item.name === 'live'
    },
    go (item) {
      this.$router.push({ name: 'trainingCamp' })
    }
  }
}
</script>
<style scoped lang='scss'>
#header {
  height: 60px;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  // background: linear-gradient(
  //   90deg,
  //   rgba(20, 79, 191, 1) 0%,
  //   rgba(14, 75, 192, 1) 38%,
  //   rgba(89, 41, 227, 1) 72%,
  //   rgba(20, 79, 191, 1) 98%
  // );
  /*background-image: url(/img/bg-header.png);*/
  /*background-size: 100% auto;*/
  background: #ffffff;
  box-shadow: 0px 2px 20px 0px rgba(32, 36, 40, .06);
  z-index: 10;
  .wrap {
    width: 1180px;
    margin: 0 auto;
    height: 60px;
    line-height: 60px;
    align-items: center;
    justify-content: space-between;
    .logo {
      float: left;
      margin-top: 17px;
    }
    .menuList {
      margin: 0;
      float: left;
      .menuList__item {
        position: relative;
        font-size: 16px;
        margin-right: 40px;
        color: rgba(255, 255, 255, 0.9);
        float: left;
        cursor: pointer;
        position: relative;
        &:hover {
          color: #ffd200;
        }
        &:last-child {
          margin-right: 0;
        }
        &.active{
          font-size: 16px;
          font-weight: 600;
          color: #2d5bff;
          .point{
            position: absolute;
            top: 45px;
            left: 50%;
            margin-left: -7px;
            display: inline-block;
            width: 16px;
            height: 5px;
            /* background-image: url(../assets/icons/icon-rectangle.png); */
            background-size: 14px 4px;
            background: #2d5bff;
            border-radius: 3px;
          }
        }
      }
    }
    .user-wrap {
      color: rgba(255, 255, 255, 0.9);
      width: 300px;
      float: right;
      text-align: right;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      .avatar {
        width: 28px;
        height: 28px;
        border-radius: 28px;
        vertical-align: middle;
        margin-right: 6px;
      }
      .user-name{
        font-size: 15px;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        color: #202428;
      }
    }
  }
}
</style>
